package com.partejar.app.feature.workspace.data

import com.partejar.app.core.network.ApiConfig
import com.partejar.app.core.network.commercialConstraintOrNull
import com.partejar.app.feature.entitlements.data.CommercialConstraintException
import com.partejar.app.core.session.SessionInvalidException
import com.partejar.app.core.session.SessionTemporarilyUnavailableException
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.patch
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.http.HttpStatusCode

interface WorkspaceRepository {
    suspend fun bootstrap(): SessionBootstrapDto
    suspend fun create(name: String): UserWorkspace
    suspend fun update(id: Long, name: String): UserWorkspace
}

class RemoteWorkspaceRepository(
    private val client: HttpClient,
    private val apiConfig: ApiConfig
) : WorkspaceRepository {
    override suspend fun bootstrap(): SessionBootstrapDto {
        val response = client.get(apiConfig.endpoint("/workspaces/me"))
        return when (response.status.value) {
            in 200..299 -> response.body()
            401 -> throw SessionInvalidException()
            else -> throw SessionTemporarilyUnavailableException()
        }
    }

    override suspend fun create(name: String): UserWorkspace {
        val response = client.post(apiConfig.endpoint("/workspaces")) {
            contentType(ContentType.Application.Json)
            setBody(WorkspaceNameRequest(name.trim()))
        }
        if (response.status == HttpStatusCode.Created) return response.body()
        throw response.commercialConstraintOrNull()
            ?: CommercialConstraintException("WORKSPACE_CREATE_FAILED")
    }

    override suspend fun update(id: Long, name: String): UserWorkspace =
        client.patch(apiConfig.endpoint("/workspaces/$id")) {
            contentType(ContentType.Application.Json)
            setBody(WorkspaceNameRequest(name.trim()))
        }.body()
}
